"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class AppService {
    static getHealth() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/app/health',
        });
    }
}
exports.AppService = AppService;
